import { h, Component } from "preact";
import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import IconTimes from "../../../common/components/icons/IconTimes";
import IconVolumeMute from "../../../common/components/icons/IconVolumeMute";
import IconCogSolid from "../../../common/components/icons/IconCogSolid";

import actions from "../../actions";

class ModalLegend extends Component {
    constructor(props) {
        super(props);
    }

    renderColorCodes(translate) {
        return (
            <p class="fxs_entryPlain_txt_small">
                <span class="fxs_half">
                    {translate("LegendColorCodeGreen", [
                        (x) => <strong class="fxs_green_txt">{x}</strong>,
                    ])}
                </span>
                <span class="fxs_half">
                    {translate("LegendColorCodeRed", [
                        (x) => <strong class="fxs_red_txt">{x}</strong>,
                    ])}{" "}
                </span>
            </p>
        );
    }

    renderAbbreviations(translate) {
        return (
            <div>
                <h2 class="fxs_headline_small">
                    {translate("LegendAbbreviations")}
                </h2>
                <p class="fxs_entryPlain_txt_small">
                    <span style="display: flex; justify-content: space-between; width:100%;">
                        {translate("LegendAbbreviationsMoM", [
                            (x) => <strong>{x}</strong>,
                        ])}

                        {translate("LegendAbbreviationsYoY", [
                            (x) => <strong>{x}</strong>,
                        ])}

                        {translate("LegendAbbreviationsQoQ", [
                            (x) => <strong>{x}</strong>,
                        ])}
                    </span>
                </p>
            </div>
        );
    }

    render({ translate, toggleModalLegend }) {
        return (
            <div class="fxs_c_modal-backdrop">
                <div class="fxs_c_modal-content">
                    <button
                        type="button"
                        class="fxs_fRight fxs_btn fxs_btn_icon fxs_modal_close"
                        onClick={toggleModalLegend}
                    >
                        <IconTimes />
                    </button>
                    <h2 class="fxs_headline_small">
                        {translate("AdvancedFilterImpactLabel")}
                    </h2>
                    <div class="fxs_quarters_flex">
                        <div class="fxs_quarter">
                            <span class="fxs_c_impact-icon fxs_c_impact-high"></span>
                            <strong>{translate("Volatility_High")}</strong>
                        </div>
                        <div class="fxs_quarter">
                            <span class="fxs_c_impact-icon fxs_c_impact-medium"></span>
                            <strong>{translate("Volatility_Medium")}</strong>
                        </div>
                        <div class="fxs_quarter">
                            <span class="fxs_c_impact-icon fxs_c_impact-low"></span>
                            <strong>{translate("Volatility_Low")}</strong>
                        </div>
                        <div class="fxs_quarter">
                            <span class="fxs_c_impact-icon fxs_c_impact-none"></span>
                            <strong>{translate("Volatility_None")}</strong>
                        </div>
                    </div>
                    <h2 class="fxs_headline_small">
                        {translate("LegendDeviation")}
                    </h2>
                    <p class="fxs_entryPlain_txt_small">
                        {translate("LegendDeviationDescription")}
                    </p>
                    <h2 class="fxs_headline_small">
                        {translate("LegendColorCode")}
                    </h2>
                    {this.renderColorCodes(translate)}
                    {translate("ShowPeriodLegend") &&
                        this.renderAbbreviations(translate)}
                    <h2 class="fxs_headline_small">
                        {translate("SoundAlert")}
                        <IconVolumeMute />
                    </h2>
                    <p class="fxs_entryPlain_txt_small">
                        {translate("SoundAlertDescription")}
                        <IconCogSolid />.
                    </p>
                </div>
            </div>
        );
    }
}
export default connectWithTranslations("", actions)(ModalLegend);
